/**
 * Unit of standalone package as container.
 */
export type StandaloneUnit = 'LITERS' | 'KILOGRAMS';

export const StandaloneUnit = {
  Liters: 'LITERS' as StandaloneUnit,
  Kilograms: 'KILOGRAMS' as StandaloneUnit,
};

export const standaloneUnits = ['LITERS', 'KILOGRAMS'] as const;
